import { Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { CompanyDetailPage } from "@/pages/dashboard/companies/detail";

/**
 * Client record. `$id/edit` is a child of this route — render `<Outlet />` when
 * editing so the form mounts instead of this detail view.
 */
export const Route = createFileRoute("/_main/dashboard/companies/$id")({
  component: () => (
    <RequirePermission action="companies.read">
      <CompanyIdLayout />
    </RequirePermission>
  ),
});

function CompanyIdLayout() {
  const showingChild = useRouterState({
    select: (state) => state.matches.some((match) => match.routeId.endsWith("/edit")),
  });
  if (showingChild) return <Outlet />;
  return <CompanyDetailPage />;
}
